import { paths } from "@rms-types/constants/paths";
import { lazy } from "react";

import { AppRoute } from "@/routes/types";

export const userManagementRoutes: AppRoute[] = [
  {
    path: paths.app.userManagement.users.path,
    permissions: paths.app.userManagement.users.permissions,
    page: lazy(() => import("@/pages/user-management/users").then((module) => ({ default: module.Users }))),
  },
  {
    path: paths.app.userManagement.roles.path,
    permissions: paths.app.userManagement.roles.permissions,
    page: lazy(() => import("@/pages/user-management/roles").then((module) => ({ default: module.Roles }))),
  },
  {
    path: paths.app.userManagement.departments.path,
    permissions: paths.app.userManagement.departments.permissions,
    page: lazy(() => import("@/pages/user-management/departments").then((module) => ({ default: module.Departments }))),
  },
];
